import { Application } from '../../blocks/common/components/application';
import { FreeResources } from '../../blocks/pages/resources/free-resources';


class Main extends Application {
    async init() {
        await super.init();

        const freeResources = new FreeResources();
        freeResources.init(this.store);
    }
}

const application = new Main();
application.init();
window['application'] = application;